import * as XLSX from 'xlsx';

export interface CustomerExportSource {
  number: string;
  name: string | null;
  attributes?: Record<string, any>;
  metadata?: Record<string, any>;
}

export const buildCustomerExportRow = ({
  number,
  name,
  attributes,
  metadata,
}: CustomerExportSource): Record<string, string> => {
  const row: Record<string, string> = { phone: number, name: name || '' };

  if (attributes) Object.entries(attributes).forEach(([key, value]) => (row[key] = value));
  if (metadata) Object.entries(metadata).forEach(([key, value]) => (row[key] = value));

  return row;
};

export const downloadCustomersXlsx = (customers: CustomerExportSource[]): void => {
  const worksheet = XLSX.utils.json_to_sheet(customers.map(buildCustomerExportRow));
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Customers');
  XLSX.writeFile(workbook, 'customers.xlsx');
};
